import { createContext } from 'react';

const sistemaStore = createContext({
  moduloPath: '',
  menuPath: '',
  subMenuPath: '',
  props: '',
  setComponentPath: ({ moduloPath, menuPath, subMenuPath, props }) => {},
  hasUnreadComunicados: false,
  setHasUnreadComunicados: () => {},
});

export default sistemaStore;
